import React from "react";
import { object, string, z } from "zod";

export const signUpSchema = object({
  email: string({ required_error: "Email is required" }).email(
    "Email is invalid"
  ),
  password: string({ required_error: "Password is required" }),
});

export const onboardingSchema = object({
  name: string({ required_error: "Full name is required" }).min(
    0,
    "Name is Incomplete"
  ),
  // dob: string({ required_error: "Date of birth is required" }).min(
  //   4,
  //   "Date of birth is required"
  // ),
});

export const forgotSchemaOne = object({
  email: string({ required_error: "Email is required" }).email(
    "Email is invalid"
  ),
});
export const forgotSchemaTwo = object({
  password: string({ required_error: "Password is required" })
    .min(7, "Password must be more than 7 characters")
    .max(32, "Password must be less than 32 characters"),
  confirmPassword: string({ required_error: "Please confirm your password" }),
}).refine((data) => data.password === data.confirmPassword, {
  path: ["comfirmPassword"],
  message: "Passwords do not match",
});
